import React, { useState, useEffect } from "react";
import { TextField, Button, Divider, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { toDate, toDecimal } from "../../utils/utils.js";
import DialogComponent from "../../common/components/DialogComponent.jsx";
import DatePickerComponent from "../../common/components/DatePickerComponent.jsx";

const CustomerEditDailog = ({ customer, uploaddate, openModal, onClose, onSave }) => {
  const [editingCustomer, setEditingCustomer] = useState();
  const parseDate = (val) => {
    if (!val) return null;
    if (val instanceof Date && !isNaN(val)) return val;
    // Try to parse string dates
    const d = new Date(val);
    return isNaN(d) ? null : d;
  };
  const handleInputChange = (field, value) => {
    setEditingCustomer((prev) => ({ ...prev, [field]: value }));
  };
  // Show raw string while typing; format to 2dp when value is a number (from DB)
  const dv = (field) => {
    const v = editingCustomer?.[field];
    return typeof v === "string" ? v : toDecimal(v);
  };
  const onDecimalBlur = (field) => {
    const num = parseFloat(editingCustomer?.[field]);
    handleInputChange(field, isNaN(num) ? 0 : num);
  };
  const formattedUploaddate = toDate(uploaddate);
  useEffect(() => {
    if (!customer) {
      setEditingCustomer(undefined);
      return;
    }
    // normalize repodate to a Date object so DatePicker works reliably
    console.log("CustomerEditDialog received customer:", customer);
    // const repod = parseDate(customer.repodate);
    // const noPayment = parseDate(customer.no_payment_received_past);
    // const noPromise = parseDate(customer.no_promise_received_past);
    // const mostRecentPayment = parseDate(customer.most_recent_payment_date);

    setEditingCustomer({
      ...customer,
      // repodate: repod,
      // no_payment_received_past: noPayment,
      // no_promise_received_past: noPromise,
      // most_recent_payment_date: mostRecentPayment,
    });
  }, [customer]);

  const handelOnSave = () => {
    console.log("Saving customer:", editingCustomer);
    // Convert repodate back to ISO string for saving, if present
    const payload = { ...editingCustomer };
    const dateFields = [
      'repodate',
      'no_payment_received_past',
      'no_promise_received_past',
      'most_recent_payment_date',
    ];
    dateFields.forEach((f) => {
      if (payload[f] instanceof Date && !isNaN(payload[f])) {
        payload[f] = payload[f].toLocaleDateString('en-CA');
      }
    });
    onSave(payload);
  }

  return (
    
    <>
      <DialogComponent
        open={openModal}
        onClose={onClose}
        title="Edit Customer"
        setWidth="lg"
        actions={
          <Button variant="contained" color="primary" onClick={handelOnSave}>
            Save
          </Button>
        }
      >
        {/* Non-Editable Fields - Grayed Out */}
        <Grid container spacing={2}>
          <Grid size={3}>
            <TextField
              label="First Name"
              value={editingCustomer?.firstname}
              fullWidth
              slotProps={{ input: { readOnly: true } }}
              size="small"
            />
          </Grid>
          <Grid size={3}>
            <TextField
              label="Last Name"
              value={editingCustomer?.lastname}
              fullWidth
              size="small"
              slotProps={{ input: { readOnly: true } }}
            />
          </Grid>
          <Grid size={2}>
            <TextField
              label="Phone Number"
              size="small"
              value={editingCustomer?.customeruniqueid}
              fullWidth
              slotProps={{ input: { readOnly: true } }}
            />
          </Grid>
          <Grid size={2}>
            <TextField
              label="Upload Date"
              value={formattedUploaddate}
              fullWidth
              size="small"
              slotProps={{ input: { readOnly: true } }}
            />
          </Grid>
          <Grid size={2}>
            <TextField
              label="Record ID"
              value={editingCustomer?.customerid}
              size="small"
              slotProps={{ input: { readOnly: true } }}
              fullWidth
            />
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2 }} />
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
          mb={2}
        ></Box>

        {/* Editable Fields */}
        <Grid container spacing={2}>
          <Grid size={2}>
            <TextField
              fullWidth
              label="Day Past Due"
              value={editingCustomer?.dayspastdue}
              onChange={(e) => handleInputChange("dayspastdue", Number(e.target.value))}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="Total Amount Due"
              value={dv("totalamountdue")}
              onChange={(e) => handleInputChange("totalamountdue", e.target.value)}
              onBlur={() => onDecimalBlur("totalamountdue")}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="Monthly Payment"
              value={dv("monthlypayment")}
              onChange={(e) => handleInputChange("monthlypayment", e.target.value)}
              onBlur={() => onDecimalBlur("monthlypayment")}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="Roll Amount"
              value={dv("rollamt")}
              onChange={(e) => handleInputChange("rollamt", e.target.value)}
              onBlur={() => onDecimalBlur("rollamt")}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="Extention Amount"
              value={dv("extamt")}
              onChange={(e) => handleInputChange("extamt", e.target.value)}
              onBlur={() => onDecimalBlur("extamt")}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="Extention Eligible"
              value={editingCustomer?.exteligible}
              onChange={(e) => handleInputChange("exteligible", e.target.value)}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="Repo Amount"
              value={dv("repoamt")}
              onChange={(e) => handleInputChange("repoamt", e.target.value)}
              onBlur={() => onDecimalBlur("repoamt")}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <DatePickerComponent
              label="Repo Date"
              date={editingCustomer?.repodate}
              onDateChange={(date) => handleInputChange("repodate", date)}
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="CC Last 4 Digits"
              value={editingCustomer?.ccdigits}
              onChange={(e) => handleInputChange("ccdigits", Number(e.target.value))}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="Amount Own Vehicle"
              value={dv("vehicleownamt")}
              onChange={(e) => handleInputChange("vehicleownamt", e.target.value)}
              onBlur={() => onDecimalBlur("vehicleownamt")}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <DatePickerComponent
              label="No Payment Received Past"
              date={editingCustomer?.no_payment_received_past}
              onDateChange={(date) => handleInputChange("no_payment_received_past", date)}
            />
          </Grid>
          <Grid size={2}>
            <DatePickerComponent
              label="No Promise Received Past"
              date={editingCustomer?.no_promise_received_past}
              onDateChange={(date) => handleInputChange("no_promise_received_past", date)}
            />
          </Grid>
          <Grid size={2}>
            <DatePickerComponent
              label="Most Recent Payment Date"
              date={editingCustomer?.most_recent_payment_date}
              onDateChange={(date) => handleInputChange("most_recent_payment_date", date)}
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="Most Recent Payment Amount"
              value={dv("most_recent_payment_amount")}
              onChange={(e) => handleInputChange("most_recent_payment_amount", e.target.value)}
              onBlur={() => onDecimalBlur("most_recent_payment_amount")}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="Minimum Payment Amount"
              value={dv("minimum_payment_amount")}
              onChange={(e) => handleInputChange("minimum_payment_amount", e.target.value)}
              onBlur={() => onDecimalBlur("minimum_payment_amount")}
              size="small"
            />
          </Grid>
          <Grid size={2}>
            <TextField
              fullWidth
              label="minimum Promise Amount"
              value={dv("minimum_promise_amount")}
              onChange={(e) => handleInputChange("minimum_promise_amount", e.target.value)}
              onBlur={() => onDecimalBlur("minimum_promise_amount")}
              size="small"
            />
          </Grid>
        </Grid>
      </DialogComponent>
    </>
  );
};

export default CustomerEditDailog;
